import React from 'react'

import Layout from "../components/layout"
import SEO from "../components/seo"
import BlogRoll from '../components/BlogRoll'

const BlogIndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <React.Fragment>
        <h1>Latest Posts</h1>
        <section>
          <div className="content">
            <BlogRoll />
          </div>
        </section>
      </React.Fragment>

  </Layout>
)

export default BlogIndexPage